import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Card, CardHeader, CardMedia, CardContent, IconButton, Typography, Chip } from '@material-ui/core'
import { connect } from 'react-redux'
import MuiTheme from '../../MuiTheme';
import { Dispatch } from 'redux';
import { ReduxStore } from '../../stores';
import { Book } from './@types';

interface Props extends WithStyles<typeof STYLES> {
    book: Book
    onClose?: () => void
}

class BookDetails extends Component<Props> {

    render() {
        const { classes, book } = this.props
        return (
            <div>
                <Card className={classes.card} >
                    <CardHeader
                        action={<IconButton onClick={this.props.onClose} ><i className='material-icons' >close</i></IconButton>}
                    />
                    <div className={classes.cardBody} >
                        <CardContent>
                            <CardMedia
                                className={classes.media}
                                component='img'
                                image={book?._pictures?.[0]?.url}
                            />
                        </CardContent>
                        <CardContent>
                            <Typography variant='h2' >{book.name}</Typography>
                            <Typography variant='subtitle2' >{book.author}</Typography>
                            {
                                book.keywords?.map((item, index) => {
                                    return (
                                        <Chip className={classes.chip} label={item} color='primary' key={index} />
                                    )
                                })
                            }
                        </CardContent>
                    </div>
                    <CardContent>
                        <Typography variant='body1' className={classes.description} >{book.description}</Typography>
                    </CardContent>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore) => ({

})

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({

})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    card: {
        position: 'relative',
        width: 700
    },
    media: {
        width: 180,
        height: '100%'
    },
    chip: {
        marginTop: 5, marginRight: 5
    },
    description: {
        marginTop: 10
    },
    cardBody: {
        display: 'flex'
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(BookDetails))